import React from 'react';
import {
  Spinner,
  Flex,
  Text,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';

interface LoadingOverlayProps {
  isLoading: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isLoading,
  message = 'Cargando...',
}) => {
  const bgColor = useColorModeValue('rgba(255, 255, 255, 0.8)', 'rgba(26, 32, 44, 0.8)');

  if (!isLoading) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      bg={bgColor}
      zIndex={9999}
    >
      <Flex
        direction="column"
        justify="center"
        align="center"
        height="100%"
      >
        <Spinner size="xl" thickness="4px" speed="0.65s" />
        <Text mt={4} fontSize="lg">
          {message}
        </Text>
      </Flex>
    </Box>
  );
};

export default LoadingOverlay;
